
const UserHomeTableTrans = ({transDescription, transDate, transTime,transID, transQuantity, transStatus }) => {

    return (
        <table className="table transactions-table table-responsive-md">
            <thead>
                <tr>
                    <th>الوصف</th>
                    <th>التاريخ</th>
                    <th>الوقت</th>
                    <th>رقم المعاملة</th>
                    <th>الكمية</th>
                    <th>الحالة</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>{transDescription}</td>
                    <td>{transDate}</td>
                    <td>{transTime}</td>
                    <td>{transID}</td>
                    <td>{transQuantity}</td>
                    <td>{transStatus}</td>
                </tr>
            </tbody>
    </table>
    );
}
export default UserHomeTableTrans;